import { ApiResponse } from 'apisauce';
import { ErrorInfo } from '../../../shared/interfaces/error-info.interface';
import api from '../../../shared/services/utils/api/api.service';
import errorHelper from '../../../shared/services/utils/api/error-helper.service';
import ReservationMapper from '../../../shared/mappers/reservation.mapper';
import { ReservationUiModel } from '../../../shared/ui-models/reservation.ui-model';

export const getModuleName = () => 'reservations-dashboard-module';

export type ReservationsDashboardSourceBookings = {
  cx: number;
  offlineSales: number;
  partners: number;
  acquisitionTeam: number;
  channelManager: number;
  app: number;
  website: number;
};

export type ReservationsDashboardSummary = {
  bookingsPrevMonth: number;
  bookingsThisMonth: number;
  sourceBookings: ReservationsDashboardSourceBookings;
  checkInIn3Days: number;
  checkOutIn3Days: number;
  currentlyInHouse: number;
  highDemandProject: {
    name: string | null;
    count: number;
  };
};

export async function getReservationsDashboardSummary(): Promise<
  ReservationsDashboardSummary | ErrorInfo
> {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const normalized: ApiResponse<any, ErrorInfo> = await (
    api as any
  ).getReservationsDashboardSummary(timezone);

  if (normalized.ok) {
    const payload = normalized.data?.data || normalized.data;
    if (payload?.data) {
      return payload.data;
    }
    return payload;
  }

  return errorHelper(
    Number(normalized.status),
    (normalized.data as any)?.errorCode
      ? String((normalized.data as any)?.errorCode || '')
      : normalized.problem,
    getModuleName(),
    'getReservationsDashboardSummary'
  );
}

export type ReservationsDashboardUpdates = {
  upcomingCheckIns: ReservationUiModel[];
  upcomingDepartures: ReservationUiModel[];
  createdRecently: ReservationUiModel[];
  currentlyHosting: ReservationUiModel[];
};

export async function getReservationsDashboardUpdates(): Promise<
  ReservationsDashboardUpdates | ErrorInfo
> {
  const normalized: ApiResponse<any, ErrorInfo> = await (
    api as any
  ).getReservationsDashboardUpdates();

  if (normalized.ok) {
    const payload = normalized.data?.data || normalized.data;
    const lists = payload?.data || payload;

    return {
      upcomingCheckIns: ReservationMapper.mapToUIList(lists?.upcomingCheckIns || []),
      upcomingDepartures: ReservationMapper.mapToUIList(lists?.upcomingDepartures || []),
      createdRecently: ReservationMapper.mapToUIList(lists?.createdRecently || []),
      currentlyHosting: ReservationMapper.mapToUIList(lists?.currentlyHosting || [])
    };
  }

  return errorHelper(
    Number(normalized.status),
    (normalized.data as any)?.errorCode
      ? String((normalized.data as any)?.errorCode || '')
      : normalized.problem,
    getModuleName(),
    'getReservationsDashboardUpdates'
  );
}
